import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=50dd81c8&"
import script from "./Priority.vue?vue&type=script&lang=ts&"
export * from "./Priority.vue?vue&type=script&lang=ts&"
import style0 from "./Priority.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports